import {FormDataConsumer, FormWithRedirect, required, useDataProvider} from "ra-core";
import {
    ArrayInput,
    AutocompleteInput,
    DateInput,
    ReferenceInput,
    SelectInput,
    SimpleFormIterator,
    TextInput,
} from "ra-ui-materialui";
import {ReferenceInputSubject} from "../../components/reference-inputs/ReferenceInputSubject";
import {useOptions} from "../../shared/hooks/useOptions";
import {AccountCompany, FormProps} from "../../shared/types";
import {initInput} from "../../shared/utils";
import {AddInvoiceLineForm} from "../components/AddInvoiceLineForm";
import {OnChange} from "react-final-form-listeners";
import {useForm} from "react-final-form";
import {updateTaxableForm} from "../utils";
import {NumberInput} from "../../components/NumberInput";
import {ReferenceInputAccountCompany} from "../../components/reference-inputs/ReferenceInputAccountCompany";
import {Card} from "@material-ui/core";
import {CustomToolbar} from "../../components/CustomToolbar";

const PurchaseInvoiceLinesInput = () => {
  const { data: optionsInvoiceLines } = useOptions("invoice-lines", "POST");
  const form = useForm();
  return optionsInvoiceLines ? (
    <ArrayInput required label="Righe fattura" source="invoice_lines" fullWidth>
      <SimpleFormIterator>
        <FormDataConsumer>
          {(propsForm) => {
            return (
              <>
                <OnChange name={propsForm.getSource!("quantity")}>
                  {(value, previous) => {
                    if (value) {
                      updateTaxableForm(
                        form,
                        propsForm.getSource!("quantity"),
                        propsForm.getSource!("price"),
                        propsForm.getSource!("vat"),
                        propsForm.getSource!("taxable"),
                        propsForm.getSource!("amount")
                      );
                    }
                  }}
                </OnChange>
                <OnChange name={propsForm.getSource!("vat")}>
                  {(value, previous) => {
                    if (value) {
                      updateTaxableForm(
                        form,
                        propsForm.getSource!("quantity"),
                        propsForm.getSource!("price"),
                        propsForm.getSource!("vat"),
                        propsForm.getSource!("taxable"),
                        propsForm.getSource!("amount")
                      );
                    }
                  }}
                </OnChange>
                <OnChange name={propsForm.getSource!("price")}>
                  {(value, previous) => {
                    if (value) {
                      updateTaxableForm(
                        form,
                        propsForm.getSource!("quantity"),
                        propsForm.getSource!("price"),
                        propsForm.getSource!("vat"),
                        propsForm.getSource!("taxable"),
                        propsForm.getSource!("amount")
                      );
                    }
                  }}
                </OnChange>
              </>
            );
          }}
        </FormDataConsumer>
        <TextInput
          {...initInput("replaced_description", optionsInvoiceLines, true)}
          label="Descrizione riga"
        />
        <NumberInput {...initInput("quantity", optionsInvoiceLines, true)} />
        <NumberInput {...initInput("price", optionsInvoiceLines, true)} />
        <NumberInput
          {...initInput("vat", optionsInvoiceLines, true)}
          defaultValue={22}
        />
        <NumberInput
          variant="outlined"
          source="taxable"
          disabled
          label="Imponibile"
          fullWidth
        />
        <NumberInput
          variant="outlined"
          source="amount"
          disabled
          label="Importo"
          fullWidth
        />
      </SimpleFormIterator>
    </ArrayInput>
  ) : null;
};
export const PurchaseCreateInvoiceForm = (props: FormProps) => {
  const { data: optionsTariff } = useOptions("tariffs", "GET");
  const { data: optionsinvoiceLines } = useOptions("invoice-lines", "GET");
  const { fieldOptions, ...rest } = props;
  const dataProvider = useDataProvider();

  const updateClient = (
    value: number,
    formProps: any
  ) => {
    if (value === null || value === undefined) {
      formProps.form.change("client", null);
      return;
    }
    dataProvider
      .getOne<AccountCompany>("accountcompany", {
        id: value,
      })
      .then(({ data: company }) => {
        if (company) {
          formProps.form.change("client", company.company.id);
        }
      });
  };

  return optionsinvoiceLines && optionsTariff ? (
    <FormWithRedirect
      {...rest}
      initialValues={{ invoice_lines: [{}] }}
      redirect="show"

      render={(formProps) => (<Card>
        <form>
          <ReferenceInputAccountCompany
            {...initInput("company", props.fieldOptions, props.canEdit)}
            required
            label="Azienda" />

          <OnChange name="company">
            {(value, previous) => {
              updateClient(value, formProps)
            }}
          </OnChange>

          <ReferenceInputSubject
            {...initInput("client", props.fieldOptions, props.canEdit)}
            filter={{ type: "client" }}
            required
            label="Intestatario"
            disabled />

          <ReferenceInputSubject
            {...initInput("supplier", props.fieldOptions, props.canEdit)}
            filter={{ type: "supplier" }}
            allowEmpty={false}
            required />
            <SelectInput
                choices={[{ value: "P", display_name: "Acquisto" }]}
                {...initInput("invoice_type", props.fieldOptions, props.canEdit, "array")}
                required
                defaultValue={"S"}
            />
          <TextInput
            {...initInput("invoice_number", props.fieldOptions, props.canEdit)}
            label="Numero fattura"
            required />
          <ReferenceInput
            {...initInput("terms_payment", props.fieldOptions, props.canEdit)}
            reference="payment-terms"
            required
            perPage={10000}
          >
            <AutocompleteInput optionText="label" />
          </ReferenceInput>
          <DateInput
            {...initInput("invoice_date", props.fieldOptions, props.canEdit)}
            required />
          <SelectInput
            choices={props.fieldOptions.type.choices}
            {...initInput("type", props.fieldOptions, props.canEdit, "array")}
            required />
          <FormDataConsumer>
            {({ formData, ...rest }) => formData.type === "NC" && (
              <ReferenceInput
                {...initInput(
                  "invoice_reference",
                  props.fieldOptions,
                  props.canEdit
                )}
                reference="autocomplete/invoice"
                validate={required()}
              >
                <AutocompleteInput optionText="label" required />
              </ReferenceInput>
            )}
          </FormDataConsumer>
          <TextInput
            defaultValue=""
            multiline
            {...initInput("causal", props.fieldOptions)}
            required />
          <TextInput
            multiline
            {...initInput("notes", props.fieldOptions, props.canEdit)} />

          <FormDataConsumer>
            {({ formData, ...rest }) => formData.id && <AddInvoiceLineForm />}
          </FormDataConsumer>
          <PurchaseInvoiceLinesInput />
          <CustomToolbar
            resource={props.resource}
            pristine={formProps.pristine}
            record={formProps.record}
            mutationMode={props.mutationMode}
            invalid={formProps.invalid}
            handleSubmitWithRedirect={formProps.handleSubmitWithRedirect}
            handleSubmit={formProps.handleSubmit}
            saving={formProps.saving}
            basePath={props.basePath}
          />
        </form>
      </Card >
      )} />

  ) : null;
};
